import './ToolbarRow.css';

import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import {
  ExpandableToolMenu,
  RoundedButtonGroup,
  ToolbarButton,
} from 'react-viewerbase';
import { commandsManager, extensionManager } from './../App.js';
import { Button, Icon } from 'antd';
import ConnectedCineDialog from './ConnectedCineDialog';
import { MODULE_TYPES } from 'ohif-core';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import i18n from 'i18next';
import qs from 'query-string';
import ConnectedLayoutButton from './ConnectedLayoutButton';
import ConnectedFollowupVisitButton from './ConnectedFollowupVisitButton';
// import ConnectedPluginSwitch from './ConnectedPluginSwitch';
import ConnectedHeatmapButtons from '../connectedComponents/ConnectedHeatmapButtons';
import { eventListener, AIIcon } from '../utils';

class ToolbarRow extends Component {
  // TODO: Simplify these? isOpen can be computed if we say "any" value for selected,
  // closed if selected is null/undefined

  static defaultProps = {
    followupLen: 0,
  };
  static propTypes = {
    isLeftSidePanelOpen: PropTypes.bool.isRequired,
    isRightSidePanelOpen: PropTypes.bool.isRequired,
    rightSidePanelDisabled: PropTypes.bool,
    selectedLeftSidePanel: PropTypes.string.isRequired,
    selectedRightSidePanel: PropTypes.string.isRequired,
    handleSidePanelChange: PropTypes.func,
    activeContexts: PropTypes.arrayOf(PropTypes.string).isRequired,
    showCharts: PropTypes.bool.isRequired,
    history: PropTypes.object,
    resource: PropTypes.object,
    followupVisibleCallBack: PropTypes.func,
    followupLen: PropTypes.number,
    applicationInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    userInfo: PropTypes.object,
  };

  constructor(props) {
    super(props);

    const toolbarButtonDefinitions = _getVisibleToolbarButtons.call(this);
    // TODO:
    // If it's a tool that can be active... Mark it as active?
    // - Tools that are on/off?
    // - Tools that can be bound to multiple buttons?

    // Normal ToolbarButtons...
    // Just how high do we need to hoist this state?
    // Why ToolbarRow instead of just Toolbar? Do we have any others?
    const search = qs.parse(window.location.search);
    this.state = {
      ...search,
      toolbarButtons: toolbarButtonDefinitions,
      activeButtons: ['Wwwc'],
      isCineDialogOpen: false,
      isBarChartEnabled: true,
      followupVisible: false,
      productionId: '101',
      pageId: '10022',
    };

    this._handleBuiltIn = _handleBuiltIn.bind(this);

    const panelModules = extensionManager.modules[MODULE_TYPES.PANEL];
    this.buttonGroups = { left: [], right: [] };

    panelModules.forEach(panelExtension => {
      const panelModule = panelExtension.module;
      const defaultContexts = Array.from(panelModule.defaultContext);
      if (
        !this.props.showCharts &&
        panelExtension.extensionId === 'ai-charts'
      ) {
        return;
      }

      // MENU OPTIONS
      panelModule.menuOptions.forEach(menuOption => {
        const contexts = Array.from(menuOption.context || defaultContexts);

        const activeContextIncludesAnyPanelContexts = this.props.activeContexts.some(
          actx => contexts.includes(actx)
        );
        if (activeContextIncludesAnyPanelContexts) {
          const menuOptionEntry = {
            value: menuOption.target,
            icon: menuOption.icon,
            bottomLabel: menuOption.label,
          };
          const from = menuOption.from || 'right';

          this.buttonGroups[from].push(menuOptionEntry);
        }
      });
    });
  }

  componentDidUpdate(prevProps) {
    const activeContextsChanged =
      prevProps.activeContexts !== this.props.activeContexts;

    if (activeContextsChanged) {
      this.setState({ toolbarButtons: _getVisibleToolbarButtons.call(this) });
    }
  }

  componentDidMount() {
    const { ishistory } = this.state;
    if (ishistory) this.setState({ followupVisible: true });
  }

  toNbox = () => {
    const { productionId, pageId } = this.state;
    const post = {
      productionId,
      pageId,
      moduleId: 'mk0002',
      elementId: 'ns-001',
      respCode: 0,
      respMsg: '成功',
    };
    eventListener(post);
    const w = window.screen.width - 10;
    const h = window.screen.height - 105;
    const { applicationInfo } = this.props;
    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${w},height=${h}`;
    window.open(applicationInfo.nboxUrl, 'nbox', str);
  };

  helpClick = () => {
    const { from, from1, type } = this.state;
    const w = window.screen.width - 10;
    const h = window.screen.height - 105;
    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${w},height=${h}`;
    let url = '';
    if (from === 'aiproduct' && type === '11') url = '/lunghelp';
    else if (from === 'screening' && from1 === 'view') url = '/screeninghelp';
    else if (from === 'report') url = '/worklisthelp';

    window.open(url, 'help', str);
  };

  overlayExpand = (isExpanded, label) => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0001' };
    if (label === '工具') eventListener({ ...eventData, elementId: 'ns-011' });
  };

  layoutButtonClick = visible => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0001' };
    let elementId = visible ? 'ns-016' : 'ns-015';
    eventListener({ ...eventData, elementId });
  };
  layoutOnChange = selectedCell => {
    const { row, col } = selectedCell;
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0001' };
    let elementId;
    // 1*1
    if (row === 0 && col === 0) elementId = 'ns-017';
    // 1*2
    else if (row === 0 && col === 1) elementId = 'ns-018';
    // 2*1
    else if (row === 1 && col === 0) elementId = 'ns-019';
    // 2*2
    else if (row === 1 && col === 1) elementId = 'ns-020';
    elementId && eventListener({ ...eventData, elementId });
  };

  render() {
    const buttonComponents = _getButtonComponents.call(
      this,
      this.state.toolbarButtons,
      this.state.activeButtons
    );

    const cineDialogContainerStyle = {
      display: this.state.isCineDialogOpen ? 'block' : 'none',
      position: 'absolute',
      top: '82px',
      zIndex: 999,
    };

    const onPress = (side, value) => {
      const { productionId, pageId } = this.state;
      const eventData = { productionId, pageId, moduleId: 'mk0001' };
      if (side === 'left') {
        eventListener({ ...eventData, elementId: 'ns-001' });
      } else if (side === 'right' && value === 'demo') {
        eventListener({ ...eventData, elementId: 'ns-021' });
      }

      this.props.handleSidePanelChange(side, value);
    };
    const onPressLeft = onPress.bind(this, 'left');
    const onPressRight = onPress.bind(this, 'right');

    const { from1, from, type } = this.state;
    const { applicationInfo } = this.props;

    let roleInfo = (this.props.userInfo.operationAuths || '').split(',');
    const isApply =
      roleInfo.indexOf('Q') >= 0 &&
      roleInfo.indexOf('M') === -1 &&
      roleInfo.indexOf('T') === -1 &&
      roleInfo.indexOf('T2') === -1;

    return (
      <>
        <div className="ToolbarRow">
          <div className="pull-left m-t-1 p-y-1" style={{ padding: '10px' }}>
            <RoundedButtonGroup
              options={this.buttonGroups.left}
              value={this.props.selectedLeftSidePanel || ''}
              onValueChanged={onPressLeft}
            />
          </div>
          {from === 'report' && (
            <ConnectedFollowupVisitButton
              followupLen={this.props.followupLen}
              followupVisibleCallBack={this.props.followupVisibleCallBack}
              dropdownVisible={this.state.followupVisible}
            />
          )}

          {buttonComponents}
          {from === 'report' && (
            <ConnectedLayoutButton
              layoutButtonClick={this.layoutButtonClick}
              layoutOnChange={this.layoutOnChange}
            />
          )}

          {/* <ConnectedPluginSwitch /> */}
          {from1 === 'aireview' ? null : (
            <ConnectedHeatmapButtons resource={this.props.resource} />
          )}

          <div className="pull-right m-t-1 rm-x-1 toolbar-right-box">
            {applicationInfo.nboxUrl && !isApply && (
              <Button className="twinkling" onClick={() => this.toNbox()}>
                <AIIcon />
              </Button>
            )}
            {((from === 'aiproduct' && type === '11') ||
              (from === 'screening' && from1 === 'view') ||
              from === 'report') && (
              <div className="toolbar-button" onClick={this.helpClick}>
                <Icon type="question-circle" />
                <div className="toolbar-button-label">帮助</div>
              </div>
            )}
            {this.buttonGroups.right.length && (
              <RoundedButtonGroup
                options={this.buttonGroups.right}
                value={this.props.selectedRightSidePanel || ''}
                onValueChanged={onPressRight}
                rightSidePanelDisabled={this.props.rightSidePanelDisabled}
              />
            )}
          </div>
        </div>
        <div className="CineDialogContainer" style={cineDialogContainerStyle}>
          <ConnectedCineDialog />
        </div>
      </>
    );
  }
}

/**
 * Determine which extension buttons should be showing, if they're
 * active, and what their onClick behavior should be.
 */
function _getButtonComponents(toolbarButtons, activeButtons) {
  return toolbarButtons.map((button, index) => {
    let activeCommand = undefined;
    if (button.buttons && button.buttons.length) {
      // Iterate over button definitions and update `onClick` behavior
      const childButtons = button.buttons.map(childButton => {
        childButton.onClick = _handleToolbarButtonClick.bind(this, childButton);

        if (activeButtons.indexOf(childButton.id) > -1)
          activeCommand = childButton.id;

        return childButton;
      });

      return (
        <ExpandableToolMenu
          key={button.id}
          // key={index}
          label={i18n.t(button.label)}
          icon={button.icon}
          buttons={childButtons}
          activeCommand={activeCommand}
          overlayExpand={this.overlayExpand}
        />
      );
    }
    return (
      <ToolbarButton
        key={button.id}
        label={i18n.t(button.label)}
        icon={button.icon}
        onClick={_handleToolbarButtonClick.bind(this, button)}
        isActive={activeButtons.includes(button.id)}
      />
    );
  });
}

/**
 * A handy way for us to handle different button types. IE. firing commands for
 * buttons, or initiation built in behavior.
 *
 * @param {*} button
 * @param {*} evt
 * @param {*} props
 */
function _handleToolbarButtonClick(button, evt, props) {
  if (button.commandName) {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0001' };
    let elementId;
    if (button.id === 'Zoom') elementId = 'ns-003';
    else if (button.id === 'Magnify') elementId = 'ns-004';
    else if (button.id === 'Wwwc') elementId = 'ns-005';
    else if (button.id === 'Pan') elementId = 'ns-006';
    else if (button.id === 'Invert') elementId = 'ns-007';
    else if (button.id === 'RotateRight') elementId = 'ns-008';
    // else if (button.id === 'FlipH') elementId = 'ns-009';
    else if (button.id === 'FlipV') elementId = 'ns-009';
    else if (button.id === 'Reset') elementId = 'ns-010';
    else if (button.id === 'Length') elementId = 'ns-012';
    else if (button.id === 'Clear') elementId = 'ns-013';
    else if (button.id === 'Download') elementId = 'ns-014';
    elementId && eventListener({ ...eventData, elementId });

    const options = Object.assign({ evt }, button.commandOptions);
    commandsManager.runCommand(button.commandName, options);
  }

  // TODO: Use Types ENUM
  // TODO: We can update this to be a `getter` on the extension to query
  //       For the active tools after we apply our updates?
  if (button.type === 'setToolActive')
    this.setState({ activeButtons: [button.id] });
  else if (button.type === 'builtIn') this._handleBuiltIn(button.options);
}

/**
 *
 */
function _getVisibleToolbarButtons() {
  const toolbarModules = extensionManager.modules[MODULE_TYPES.TOOLBAR];
  const toolbarButtonDefinitions = [];
  toolbarModules.forEach(extension => {
    const { definitions, defaultContext } = extension.module;
    definitions.forEach(definition => {
      const context = definition.context || defaultContext;

      if (this.props.activeContexts.includes(context))
        toolbarButtonDefinitions.push(definition);
    });
  });

  return toolbarButtonDefinitions;
}

function _handleBuiltIn({ behavior } = {}) {
  if (behavior === 'CINE')
    this.setState({ isCineDialogOpen: !this.state.isCineDialogOpen });
}

export default withTranslation('Common')(withRouter(ToolbarRow));
